import React from 'react';

export const PTQD = () => {
  return (
    <div>Trang phân tích quyết định</div>
  )
}